import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { DateObject } from "@/classes";
import { computed, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dialog = ref(false);
const prevTime = ref(0);

watch(
  () => dialog.value,
  () => {
    if (!dialog.value) {
      const currTime = props.modelValue?.datetimeValue.getTime() ?? 0;
      if (currTime !== prevTime.value) {
        emit("change");
      }
    }
  }
);

const dateModel = computed({
  get: () => {
    return props.modelValue ? props.modelValue.datetimeValue : null;
  },
  set: (value) => {
    emit("update:modelValue", value ? new DateObject(value) : null);
  },
});

const dateDisplay = computed(() => {
  if (props.modelValue)
    return props.modelValue.datetimeValue.toLocaleDateString();
  return "";
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, _mergeProps(_ctx.$attrs, {
      "model-value": dateDisplay.value,
      "prepend-inner-icon": "mdi-calendar",
      readonly: "",
      "onClick:prependInner": _cache[0] || (_cache[0] = ($event: any) => {
      dialog.value = true;
      prevTime.value = props.modelValue?.datetimeValue.getTime() ?? 0;
    })
    }), null, 16, ["model-value"]),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
      "max-width": "328"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: dateModel.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateModel).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})